/**
 * Logo — Verified Demand brand mark.
 *
 * iter107 — Replaces the "Verified Demand" placeholder text + purple
 * diamond mark with the real brand logo. Auto-picks dark or light
 * variant based on `variant` prop:
 *   - variant="dark"  → use the dark-mode logo (use on light surfaces)
 *   - variant="light" → use the light-mode logo (use on dark surfaces
 *                       like the navy sidebar)
 *
 * NOTE on naming: the file `logo-dark.png` is the logo *designed for*
 * a dark background (i.e. light/white type). The file `logo-light.png`
 * is designed for a light background (dark type). Callers pass the
 * variant matching THEIR background.
 */
const LOGO_FOR_DARK_BG  = "/brand/logo-dark.png";   // light type on transparent
const LOGO_FOR_LIGHT_BG = "/brand/logo-light.png";  // dark type

export const Logo = ({ variant = "light", className = "", height = 28, alt = "Verified Demand" }) => {
  const src = variant === "dark"
    ? LOGO_FOR_DARK_BG    // background is DARK → use the light-type logo
    : LOGO_FOR_LIGHT_BG;  // background is LIGHT → use the dark-type logo
  return (
    <img
      src={src}
      alt={alt}
      height={height}
      style={{ height, width: "auto", display: "block" }}
      className={className}
      data-testid="verified-demand-logo"
    />
  );
};

export default Logo;
